import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice";
import React from "react";

export default function GroceryMarket({data}) {
    const dispatch = useDispatch();

  return (
  <>
     <section className={`bolt-for-you-area grocery-for-you-area  ${data && data.newClass}`}>
        <div className="container">
          <div className="row ">
            <div className="col-lg-12">
              <div className="bolt-for-you-head">
                <div className="row">
                  <div className="col-lg-7 col-xl-5">
                    <h3 className="heading"> <span> {data && data.text1} </span> <br/>{data && data.text2}</h3>
                    <p> {data && data.des} </p>
                    <button onClick={() => dispatch(openPopup())} className="default-white">{data && data.btn}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
</>
  )
}



